<template>
  <section :class="sectionPadding" v-if="hasRequestContentResponse && requestContentItem" data-testid="request-content-info-component">
    <div class="flex flex-col gap-2 w-full dark:text-zinc-300">
      <div class="flex items-center gap-2">
        <Icon size="sm" name="general.chatAnswer" />
        <span class="text-sm font-bold">Reply to:</span>
      </div>
      <div class="flex flex-wrap gap-2 text-base">
        <div class="flex truncate items-center gap-2">
          <p data-testid="request-content-info-name" class="truncate">{{ requestContentItem.name }}</p>
          <a
            data-testid="request-content-info-link"
            class="text-blue-500"
            v-if="requestContentItem.requestLink"
            :href="requestContentItem.requestLink"
            target="_blank"
            alt="Request Link"
          >
            <Icon size="xs" name="general.externalLink" />
            <span class="sr-only">External link to the request</span>
          </a>
        </div>
        <span class="flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light">|</span>
        <p data-testid="request-content-info-custom-id" v-if="requestContentItem.customId" class="flex-shrink-0">
          Custom ID: {{ requestContentItem.customId }}
        </p>
        <span class="flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light">|</span>
        <a class="text-blue-500 flex gap-1 items-center" :href="`/collections/${requestContentItem.collectionId}`" target="_blank">
          <Icon size="xs" name="general.turnDownRight" />
          Collection
        </a>
        <template v-if="insightsURL">
          <span class="flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light">|</span>
          <a class="text-blue-500 flex gap-1 items-center" data-testid="request-content-info-download-logs" :href="insightsURL" target="_blank">
            <Icon size="xs" name="general.downloadFile" />
            Download logs
          </a>
        </template>
        <span class="flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light">|</span>
        <template v-for="param in requestParamsToDisplay" :key="param.key">
          <p class="property" :data-testid="`request-content-info-query-params-${param.key}`">{{ param.key }}: {{ param.value }}</p>
          <span class="divider">|</span>
        </template>

        <template v-if="requestContentParamsCount > REQUEST_PARAMS_TO_DISPLAY_COUNT">
          <a
            class="text-blue-500 flex gap-1 items-center"
            href="#"
            @click.stop.prevent="showRequestContentParamsModal"
            target="_blank"
            data-testid="request-content-info-query-params-more"
            >More</a
          >
        </template>
      </div>
      <HorizontalDivider v-if="showHorizontalDivider" />
    </div>
  </section>
</template>
<script lang="ts" setup>
import { Icon, HorizontalDivider } from '@/storybook';
import { computed, onMounted } from 'vue';
import { useRequestContentInfoPage, REQUEST_PARAMS_TO_DISPLAY_COUNT } from '../composables/useRequestContentInfoPage';
import { useViewerItemStore } from '../store/useViewerItemStore';
import { useArtifactsStore } from '../store/useArtifactsStore';

const { loadData, showRequestContentParamsModal, requestContentItem, showHorizontalDivider, requestParamsToDisplay, requestContentParamsCount } =
  useRequestContentInfoPage();

const { hasRequestContentResponse } = useViewerItemStore();
const { insightsURL } = useArtifactsStore();

const sectionPadding = computed(() => (showHorizontalDivider.value ? 'px-4 pt-4' : 'p-4'));

onMounted(() => {
  if (hasRequestContentResponse) {
    loadData();
  }
});
</script>

<style scoped>
.property {
  @apply flex-shrink-0 max-w-[30ch] truncate;
}
.divider {
  @apply flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light;
}
</style>
